import React from 'react';
import {useStateContext} from "../contexts/ContextProvider";

import { FaBookmark } from "react-icons/fa";

export const Navbar = () => {
    const {main, setMain, requestBookmarkJump} = useStateContext();

    const handleClick = lang => {
        setMain(lang);
    }

    const active = "border-l border-t border-r rounded-t text-blue-700";
    const inactive = "text-blue-500 hover:text-blue-800";

    const liActive = "-mb-px";

    return (
        <nav className="fixed top-0 w-full">
            <ul className="flex border-b float-right">
                {/* Bookmark Icon */}
                <li className="mr-1">
                    <button
                        type="button"
                        onClick={requestBookmarkJump}
                        className="inline-block py-2 px-4 font-semibold text-blue-500 hover:text-blue-800"
                    >
                        <FaBookmark /> {/* Use the bookmark icon */}
                    </button>
                </li>
                {/* Language Selection */}
                <li className={`mr-1 ${main === "eng" && liActive}`}>
                    <span
                        className={`bg-white inline-block py-2 px-4 font-semibold ${main === "eng" 
                            ? active 
                            : inactive}`
                        }
                        onClick={() => handleClick("eng")}
                    >English</span>
                </li>
                <li className={`mr-1 ${main === "hun" && liActive}`}>
                    <span
                        className={`bg-white inline-block py-2 px-4 font-semibold ${main === "hun"
                            ? active
                            : inactive
                        }`}
                        onClick={() => handleClick("hun")}
                    >Magyar</span>
                </li>
            </ul>
        </nav>
    )
};
